// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"20d0e840","453":"4ee30f3f","455":"c4b42b6d"}[chunkId] + ".chunk.js";
};